<template>

        <form>

            <p v-if="group && group.archived">Voor volgend schooljaar kun je je aanmelden bij een nieuwe klas. Voer dan hieronder de uitnodigingscode in die je van jouw docent hebt gekregen.</p>
            <p v-else-if="group">Je zit nu in klas <strong>{{ group.name }}</strong>.
            Wil je naar een andere klas verhuizen? Voer dan hieronder de uitnodigingscode van de nieuwe klas in.</p>
            <p v-else>Vul hieronder de uitnodigingscode van jouw klas in. Deze code krijg je van je docent.</p>

            <div class="input-group" :class="{ error : containsError('code')}">
                <label for="code">Uitnodigingscode</label>
                <input type="text" name="code" id="code" v-model="code" @keydown.enter.prevent="submit" :autofocus="!isTouch"  />
            </div>

            <p class="note note--info" v-if="group"><strong>Let op:</strong> je kunt nu nog je huidige werkmap bekijken. Zodra je naar een nieuwe klas verhuist krijg je ook een nieuwe werkmap.</p>


            <primary-button @clicked="submit" :loading="loading" >{{ group ? 'Verhuizen' : 'Aanmelden' }}</primary-button>

        </form>

</template>


<script>
import api from 'js/api/resources'
import { storeUserResponse } from 'js/vuex/actions'
import notify from 'js/components/notifications/notificationsMixin'
import validation from 'js/components/auth/validationMixin'
import touch from 'js/components/auth/touchMixin'

import PrimaryButton from 'js/components/elements/PrimaryButton.vue'

export default {
    name: 'SettingsGroup',
    mixins: [ notify, validation, touch ],
    components: { PrimaryButton },

    props: {
        user: {},
    },

    data: function() {
        return {
            code: null,
            loading: false,
            errors: [],
            errorFields: [],
        }
    },

    vuex: {
        actions: {
            moveToGroup: function({dispatch}, user, code) {
                return api.moveToGroup(user.id, code)
                    .then( response => storeUserResponse({dispatch}, response, true))
            }

        }
    },

    computed: {
        group: function() {
            const groupId = this.user.groups ? this.user.groups[0] : null
            if (groupId == null) {
                return null
            }

            return this.$store.state.groups.storage[groupId]
        },
    },

    methods: {
        submit: function(e) {

            e.preventDefault();

            if ( this.validate() ) {

                this.loading = true

                this.moveToGroup(this.user, this.code)
                    .then( () => {
                        this.$success('Welkom in klas ' + this.group.name )
                        this.$router.push({ name: 'root'})
                        this.$emit('done')
                    })
                    .catch( response => {
                        this.handleErrorResponse(response, 'Overplaatsen naar nieuwe klas is mislukt.')
                    })
                    .then(this.reset)

            }

        },

        reset: function() {
            this.code = null
            this.loading = false
        },

        validateFields: function() {
            this.validateCode(this.code)
        },

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Group.vue?1e6e12b9